import { Modal } from "react-bootstrap";
import styles from "./index.module.scss";
import { Button } from "react-bootstrap";

const WinterNotification = ({ show, onHide }) => {
  return (
    <Modal show={show} size="md" backdrop="static" onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title className="flex">
          <i className="bi bi-snow"></i>&nbsp;Зимова перерва
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <>
          <p>Шановні учасники!</p>
          <p>
            Під час зимової перерви{" "}
            <u>
              ми оновимо трансферну вартість футболістів, обнулимо ваші склади
            </u>{" "}
            та попросимо вас&nbsp;
            <strong>зібрати склад заново</strong>.
          </p>
          <p>
            Щоб не проґавити цей момент підпишіться на{" "}
            <a
              href={process.env.REACT_APP_TELEGRAM_CHANNEL_LINK}
              target="_blank"
              rel="noreferrer"
            >
              телеграм канал {process.env.REACT_APP_FANTASY_TITLE}
            </a>{" "}
            або{" "}
            <a
              href="https://www.instagram.com/footbattle.click?igsh=cmdtZHFhZWliajR5&utm_source=qr"
              target="_blank"
              rel="noreferrer"
            >
              інстаграм Фентезі Футбол
            </a>
            .
          </p>
        </>

        <div className={styles.actions}>
          <Button className={styles.btn} onClick={onHide}>
            <i className="bi bi-check2-all"></i>&nbsp;ОК
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WinterNotification;
